import { useContext, useEffect, useRef } from 'react';
import './AppMenu.scss';
import { useSelector } from 'react-redux';
import ThemeContext from '../../context/themeProvider';
import { faGlobe, faMoon, faSun } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import store from '../../store/store';
import appSlice from '../../store/appSlice';
import translations from '../../translations';

function AppMenu(props) {
  const isOpen = useSelector((state) => state.app.appMenuOpen);

  const { theme, setTheme } = useContext(ThemeContext);

  const elementRef = useRef(null);

  const languageCode = useSelector((state) => state.app.geolocation.languageCode);
  const t = translations[languageCode];

  function onWindowClick(e) {
    if (!elementRef.current.contains(e.target) && !document.querySelector('.app-menu-container').contains(e.target)) {
      store.dispatch(appSlice.actions.toggleAppMenu(false));
    }
  }

  useEffect(() => {
    window.addEventListener('click', onWindowClick);

    return () => {
      window.removeEventListener('click', onWindowClick);
    };
  }, []);

  return (
    <div className={`AppMenu ${theme} ${isOpen ? '' : 'hidden'}`} ref={elementRef}>
      <div
        className="language"
      >
        <button>
          <FontAwesomeIcon icon={faGlobe} size="lg" />
        </button>
        <span>{t.language}</span>
      </div>
      
      <div
        className="theme"
        onClick={() => theme === 'light' ? setTheme('dark') : setTheme('light')}
      >
        {
          theme === 'light'
            ? <button><FontAwesomeIcon icon={faMoon} size="lg" /></button>
            : <button><FontAwesomeIcon icon={faSun} size="lg" /></button>
        }
        <span>{t.theme}</span>
      </div>
    </div>
  );
}

export default AppMenu;
